import type { FC } from 'react';
import type { ObjectWithContributors } from 'src/rbac/Permission';
import { useHasPermissionQuery } from 'src/rbac/useHasPermission';

import { useIsModuleEnabled } from '@/hooks/useIsModuleEnabled';

import DocumentRatingRegister from './DocumentRatingRegister';
import InternalAuditDocumentRatingRegister from './InternalAuditDocumentRatingRegister';
import OversightDocumentRatingRegister from './OversightDocumentRatingRegister';

interface Props {
  parent: ObjectWithContributors;
}

const Tab: FC<Props> = ({ parent }) => {
  const oversightEnabled = useIsModuleEnabled(
    'assessment.subModules.oversight_register_and_findings'
  );
  const internalAuditEnabled = useIsModuleEnabled('internal_audit_entity');
  const {
    hasPermission: canViewCompliance,
    loading: canViewComplianceLoading,
  } = useHasPermissionQuery('read:oversight_assessment', parent);
  const {
    hasPermission: canViewInternalAudit,
    loading: canViewInternalAuditLoading,
  } = useHasPermissionQuery('read:internal_audit_report', parent);

  return (
    <>
      <DocumentRatingRegister parent={parent} />
      {oversightEnabled && canViewCompliance && !canViewComplianceLoading && (
        <OversightDocumentRatingRegister parent={parent} />
      )}
      {internalAuditEnabled &&
        canViewInternalAudit &&
        !canViewInternalAuditLoading && (
          <InternalAuditDocumentRatingRegister parent={parent} />
        )}
    </>
  );
};

export default Tab;
